import React, { useEffect, useState } from 'react';
import { Alert, Container, Progress, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { OptionsList } from './OptionsList';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { questionnaireItemsActions } from '../../../../core/questionnaire-items/actions';
import { questionnaireStoreOptionsActions } from '../../../../core/questionnaire-storeOptions/actions';
import LoadingIndicator from '../../loading-indicator/loading-indicator';
import Select from 'react-select';
import { Optioncustom } from '../questions-review/OptionCustom';
import { Link } from 'react-router-dom';

export const Question = ({ handleNextSection }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const questionnaire_list = useSelector(state => state.questionnaire_list);
    const [sectionActive, setSectionActive] = useState('');
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [optionSelected, setOptionSelected] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const [allValid, setAllValid] = useState(true);

    const [modal, setModal] = useState(false);
    const [timer, setTimer] = useState(null);
    const [secondsRemaining, setSecondsRemaining] = useState(5);


    const toggleModal = () => {
        setModal(!modal);
        if (!modal) {
            setSecondsRemaining(5);
            const intervalId = setInterval(() => {
                setSecondsRemaining((prevSeconds) => {
                    if (prevSeconds === 1) {
                        clearInterval(intervalId);
                        setModal(false);
                        handleNextSection('finish')
                    }
                    return prevSeconds - 1;
                });
            }, 1000);
            setTimer(intervalId);
        } else {
            clearInterval(timer);
            handleNextSection('finish')
        }
    };


    useEffect(() => {
        let isMounted = true;

        if (isMounted) {
            dispatch(questionnaireItemsActions.loadQuestionnaireItems(Number(id)));
        }

        return () => {
            isMounted = false;
        }
    }, []);


    useEffect(() => {
        if (questionnaire_list.data?.items?.length > 0) {
            setSectionActive(questionnaire_list.data.items[0].id);
        }
    }, [])

    const questionItem = () => {
        setCurrentQuestion(questionnaire_list.data.items && questionnaire_list.data.items.find(question => sectionActive === question.id));
    }

    useEffect(() => {
        questionItem();
    }, [sectionActive, questionnaire_list])

    const alertCondition = () => {
        if ((currentQuestion && currentQuestion.type === 'chk') || (currentQuestion && currentQuestion.type === 'opt')) {
            return <>
                {currentQuestion && currentQuestion.type === 'chk' ?
                    currentQuestion.help_text : currentQuestion.help_text}
            </>
        } else {
            return null;
        }
    }

    const positionElement = (question) => {
        return questionnaire_list.data.items.findIndex(
            item => item.id === question.id
        ) + 1;
    }

    const buildOptions = (optionId, checked) => {
        if (checked) {
            setOptionSelected([
                ...optionSelected,
                {
                    id: optionId,
                    checked
                }
            ])
        } else {
            setOptionSelected(
                optionSelected.filter(option => option.id !== optionId)
            )
        }
    }


    const nextQuestion = (finish) => {
        if (areAllValid()) {
            dispatch(questionnaireStoreOptionsActions.saveQuestionnaireStoreOptions({ questionnaireId: id, questionId: currentQuestion.id, options: optionSelected }));
            finish ? toggleModal() : setSectionActive(questionnaire_list.data.items[positionElement(currentQuestion)].id);
            setDisabled(true);
            setOptionSelected([])
            setShowAlert(false)
            dispatch(questionnaireItemsActions.nextQuestionQuestionnaireItems());
            window.scrollTo(0, 0);
        } else {
            setAllValid(false);
        }
    }

    useEffect(() => {
        disabledBtnContinue()
    }, [optionSelected]);


    const disabledBtnContinue = () => {
        var valid = true;

        if (currentQuestion && currentQuestion.minimum && currentQuestion.maximum) {
            if (optionSelected.length > currentQuestion.maximum || optionSelected.length < currentQuestion.minimum) {
                valid = false;
            } else {
                valid = true;
            }

            setDisabled(!valid);

            if (optionSelected.length)
                setShowAlert(!valid);
        }
    }

    const transformItemsIntoNameValue = (list) => {
        return list && list.map((element) => {
            return { value: element.id, label: element.title };
        });
    };

    const newList = transformItemsIntoNameValue(currentQuestion && currentQuestion.options && currentQuestion.options);


    const onChangeSelectedOption = (selectedOption) => {
        setOptionSelected([{ id: selectedOption.value }])
    }

    const optionCustomSelected = (opt) => {
        let value = false
        if (opt.custom_enable) {
            optionSelected.forEach(option => {
                if (option.id.toString() === opt.id.toString()) {
                    value = true
                }
            });
        }
        return value
    }

    const setValue = (target) => {
        optionSelected.forEach(option => {
            if (target.id.toString() === option.id.toString()) {
                option.custom_value = target.value;
            }
            if (areAllValid()) {
                setAllValid(true);
            }
        });
    }

    const validText = (optionId, mandatory) => {
        let valid = true;
        if (mandatory) {
            optionSelected.forEach(opt => {
                if (optionId.toString() === opt.id.toString()) {
                    if (!opt.custom_value || opt.custom_value === undefined || opt.custom_value == '') {
                        valid = false;
                    }
                }
            });
        }
        return valid
    }

    const areAllValid = () => {
        let boolean = true;
        currentQuestion.options.forEach(option => {
            optionSelected.forEach(opt => {
                if (option.custom_mandatory && option.id.toString() === opt.id.toString()) {
                    if (!validText(option.id, option.custom_mandatory)) {
                        boolean = false
                    }
                }
            });
        });
        return boolean;
    }

    return (
        <>
            <div className="w-100 h-100">
                <Container fluid="lg" className="content-questions w-100 h-100 p-0">
                    <div className="py-md-3 px-md-3 rounded border-md h-100">

                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <Progress value={questionnaire_list.starts_from - 1} max={questionnaire_list.data && questionnaire_list.data.total_items} className='flex-fill progress-sm' />
                            <div className="paginador mx-3 small font-weight-semibold">{questionnaire_list.starts_from - 1}/{questionnaire_list.data && questionnaire_list.data.total_items}</div>
                            <div className="d-flex justify-content-center align-items-center">
                                <Link className="icon-close" to="/home"></Link>
                            </div>
                        </div>

                        {currentQuestion &&
                            <>

                                <div className="pb-5">
                                    <div className="d-flex align-items-md-center mb-4">
                                        <div className='mr-3'><div className="rounded-circle question-member bg-ice-60 text-center font-weight-bold">{questionnaire_list.starts_from}</div></div>
                                        <div>
                                            {currentQuestion.title && <h2 className="mb-0 h5">{currentQuestion.title}</h2>}
                                            {currentQuestion.subtitle && <p className='mb-0'>{currentQuestion.subtitle}</p>}
                                        </div>
                                    </div>

                                    {alertCondition() && <Alert color="primary" className="text-center font-weight-semibold border-0 py-2"><i>{alertCondition()}</i></Alert>}

                                    {(currentQuestion.type === "opt" || currentQuestion.type === "chk") &&
                                        <OptionsList
                                            currentQuestion={currentQuestion}
                                            buildOptions={buildOptions}
                                            setOptionSelected={setOptionSelected}
                                            setValue={setValue}
                                            validText={validText}
                                            allValid={allValid}
                                            optionCustomSelected={optionCustomSelected}
                                        />
                                    }

                                    {currentQuestion.type === "sel" &&
                                        <div className="select-years-content ml-5 pl-1 pt-3 ml-md-0 pl-md-0 pt-md-0">
                                            <Select options={newList} defaultValue={onChangeSelectedOption}
                                                onChange={onChangeSelectedOption} className="form-control-select select-years d-md-inline-block" classNamePrefix="form-control" placeholder={currentQuestion.help_text && currentQuestion.help_text} />

                                            {currentQuestion.options && currentQuestion.options.map((option) =>
                                                <div key={option.id}>
                                                    {
                                                        optionCustomSelected(option) &&
                                                        <Optioncustom
                                                            option={option}
                                                            setValue={setValue}
                                                            validText={validText}
                                                            allValid={allValid}
                                                            setOptionSelected={setOptionSelected}
                                                        />
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    }
                                </div>

                                {currentQuestion.validation_message &&
                                    <>
                                        {(disabled && showAlert) &&
                                            <div className="text-danger text-center mb-3"><p className="mb-0">{currentQuestion.validation_message}</p></div>
                                        }
                                    </>
                                }

                                <div className="contenido-bottom-fixed-mb text-center">
                                    {positionElement(currentQuestion) < questionnaire_list.data.items.length ?
                                        <>
                                            <Button size="sm" color='outline-green-light' onClick={() => nextQuestion(false)} disabled={disabled}>
                                                Next
                                                <i className="ml-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px' }}>
                                                        <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z" />
                                                    </svg>
                                                </i>
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button size="sm" color='outline-green-light' onClick={() => nextQuestion(true)} disabled={disabled}>
                                                Next
                                                <i className="ml-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px' }}>
                                                        <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z" />
                                                    </svg>
                                                </i>
                                            </Button>
                                        </>
                                    }
                                </div>
                            </>
                        }
                    </div>
                </Container>
            </div>

            {
                questionnaire_list.isPending && <LoadingIndicator className="text-center" />
            }

            {questionnaire_list?.data?.questionnaire &&
                <>
                    <Modal isOpen={modal} toggle={toggleModal} centered size='md' className='close-circle'>
                        <ModalHeader toggle={toggleModal} className='justify-content-center border-0 pb-0' cssModule={{ 'modal-title': 'modal-title libre-caslon-text-regular h4 mt-3' }}>You completed the {questionnaire_list.data.questionnaire.name} questionnaire</ModalHeader>
                        <ModalBody>
                            <div className='text-center'>
                                <div className='icon mb-4 rounded-circle bg-green p-3 d-inline-block text-white mx-auto'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill='currentColor'>
                                        <path d="M38,14.7L18,34.8c-0.5,0.5-1.1,0.7-1.8,0.7c-0.7,0-1.3-0.3-1.8-0.7L3.2,23.5c-0.5-0.5-0.7-1.1-0.7-1.8
                        c0-0.7,0.3-1.3,0.7-1.8l3.1-3.1c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.3,0.3,1.8,0.7l6.4,6.2L31.4,8.1c0.5-0.5,1.1-0.7,1.8-0.7
                        s1.3,0.3,1.8,0.7l3.1,3.1c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.3,0.2,0.6,0.2,1c0,0.3-0.1,0.7-0.2,1C38.4,14.2,38.3,14.5,38,14.7z"/>
                                    </svg>
                                </div>
                                <p className='h4 font-weight-semibold'>Congratulations!</p>
                                <p className='h5 font-weight-normal mb-4'>Now review and submit your results</p>
                                <p className='text-muted'><small>Redirecting to review & rearrange in {secondsRemaining}s</small></p>
                            </div>
                        </ModalBody>
                    </Modal>
                </>
            }
        </>
    )
}